import { Grid, Typography, MenuItem } from '@material-ui/core';
import { useFormState, useForm } from 'react-final-form';
import React, { useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import _ from 'lodash';

import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../../../../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXTextField from '../../../../../shared-components/text-field/QCXTextField';
import QCXSelectDespesaReceitaAutocomplete from '../../../../../shared-components/select-despesa-receita/QCXSelectDespesaReceitaAutocomplete';
import QCXFinalBondManager from '../../../../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';

import {
  selectDespesasReceitas,
} from '../../../../../features/despesa-receita/despesaReceitaSlice';

import {
  selectMoedas,
} from '../../../../../features/moeda/moedaSlice';
import QCXFinalSelectGenericoAutocomplete from '../../../../../shared-components/select-tipo-frete/QCXFinalSelectGenericoAutocomplete';


export default function SelectManyCustosAdicionais({
  initialValues,
  handleSubmit,
  isConsult,
  isUpdate,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  list = [],
}) {

  const form = useForm();
  const { values } = useFormState();
  const { t } = useTranslation();


  const moedasList = useSelector(selectMoedas);
  const despesasList = useSelector(selectDespesasReceitas);


  const [tipoPagamento, setTipoPagamento] = React.useState(initialValues?.tipoPagamento || 'PREPAID');

  const handleTipoPagamentoChange = (event) => {
    setTipoPagamento(event.target.value)
  };


  const codigoInternoProps = useMemo(
    () => ({
      name: "custosAdicionais",
      columns: [
        {
          field: 'despesaReceita.description',
          headerName: 'Despesa/Receita',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => row?.despesaReceita?.description,
        },
        {
          field: 'moeda.description',
          headerName: 'Moeda',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => row?.moeda?.description,
        },
        {
          field: 'tipoPagamento',
          headerName: 'Tipo Pagamento',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => row?.tipoPagamento,
        },
        {
          field: 'valorCompra',
          headerName: 'Valor Compra',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => row?.valorCompra,
        }
      ],
    }),
    []
  );


  const codigoInternoFormProps = useMemo(
    () => ({
      rootName: `ignorableFields`,
      fields: [
        {
          name: 'despesaReceita.id',
          label: 'Despesa / Receita',
          required: false,
        },
        {
          name: 'moeda.id',
          label: 'Moeda',
          required: false,
        },
        {
          name: 'tipoPagamento',
          label: 'Tipo de Pagamento',
          required: false,
        },
        {
          name: 'valorComprar',
          label: 'Valor Comprar',
          required: false,
        },
      ],
    }),
    []
  );

  const findByIdArr = (arr, id) => {
    if (!_.isArray(arr)) {
      return null;
    }

    return arr.find((el) => el.id === id);

  }

  const handleAddCusto = useCallback(
    async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {

      const novoCusto = {
        id: uuid(),
        despesaReceita: findByIdArr(despesasList, currentVinculo.despesaReceita.id),
        moeda: findByIdArr(moedasList, currentVinculo.moeda.id),
        tipoPagamento,
        valorCompra: currentVinculo.valorComprar,
      };

      if (_.isArray(currentVinculos)) {
        form.change('custosAdicionais', [...currentVinculos, novoCusto]);
      } else {
        form.change('custosAdicionais', [novoCusto]);
      }

      form.change('ignorableFields.despesaReceita', null);
      form.change('ignorableFields.moeda', null);
      form.change('ignorableFields.tipoPagamento', null);
      form.change('ignorableFields.valorCompra', null);
    },
    [values]
  );

  const handleUpdateCusto = useCallback(
    async (currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
      if (!currentVinculo?.id) {
        return;
      }
      if (!_.isArray(currentVinculos)) {
        return;
      }

      const { id } = currentVinculo;
      const vinculos = [...currentVinculos];
      const index = vinculos.findIndex((el) => el.id === id);

      if (index === -1) {
        return;
      }

      vinculos[index] = { ...currentVinculo };
      form.change('custosAdicionais', [...vinculos]);

      form.change('ignorableFields.despesaReceita', null);
      form.change('ignorableFields.moeda', null);
      form.change('ignorableFields.tipoPagamento', null);
      form.change('ignorableFields.valorCompra', null);
    },
    [values]
  );

  const handleAlreadyExistsFornecedor = useCallback((currentVinculo, currentVinculosList) => false, []);


  return (
    <>
      <QCXFinalBondManager
        isParentConsult={isConsult}
        listProps={codigoInternoProps}
        formProps={codigoInternoFormProps}
        handleAdd={handleAddCusto}
        handleUpdate={handleUpdateCusto}
        handleAlreadyExists={handleAlreadyExistsFornecedor}
        forceShowDelete
      >
        <Grid item xs={12} sm={3} md={3} lg={3}>
          <QCXSelectDespesaReceitaAutocomplete
            id="despesa-receita-field"
            key="despesa-receita-field"
            name="ignorableFields.despesaReceita.id"
            label="Despesa / Receita"
            disabled={isConsult}
            filtrarDespesaReceita
          />
        </Grid>

        <Grid item xs={12} sm={3} md={3} lg={3}>
          <QCXSelectMoedaAutocomplete
            id="moeda-field"
            key="moeda-field"
            name="ignorableFields.moeda.id"
            label="Moeda"
            disabled={isConsult}
          />
        </Grid>
        
        <Grid item xs={12} sm={2} md={2} lg={2}>
          <QCXFinalSelectGenericoAutocomplete
            id="tipo-pagamento-field"
            key="tipo-pagamento-field"
            name="ignorableFields.tipoPagamento"
            label="Tipo de Pagamento"
            optionsProp={[{ label: 'Prepaid', value: 'PREPAID' },
            { label: 'Collect', value: 'COLLECT' }]}
            fieldProps={{ validate: undefined }}
            disabled={isConsult}
          />
        </Grid>

        <Grid item xs={12} sm={3} md={3}>
          <QCXFinalAlternativeCurrencyField
            id="valor-comprar-field"
            name="ignorableFields.valorComprar"
            label="Valor Comprar"
            key="valor-valor-comprar-field"
            disabled={isConsult}
          />
        </Grid>
      </QCXFinalBondManager>
    </>
  )
}
